export default __webpack_public_path__ + "static/man2-7e03845827e508c63e7f204dd33b098b.png";